<template>
  <div class="logo-container">
    <img alt="RueBaRue logo" src="/images/ruebarue-logo.svg" class="logo" />
  </div>
  <div class="uk-height-viewport uk-flex uk-flex-center" style="align-items: flex-start; padding-top: 100px;">
    <div class="uk-width-large uk-card uk-card-default uk-card-body uk-box-shadow-large">
      <h3 class="uk-card-title uk-margin-bottom">Login</h3>
      <form @submit.prevent="handleLogin">
        <div v-if="error" class="uk-alert-danger uk-margin-top" uk-alert>
          {{ error }}
        </div>
        <div class="uk-margin">
          <input
            class="uk-input"
            type="email"
            placeholder="Email"
            v-model="email"
            required
          />
        </div>

        <div class="uk-margin">
          <input
            class="uk-input"
            type="password"
            placeholder="Password"
            v-model="password"
            required
          />
        </div>

        <div class="uk-margin">
          <button
            class="uk-button uk-button-primary uk-width-1-1"
            type="submit"
          >
            Login
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store.js";

export default {
  name: "LoginView",
  data() {
    return {
      email: "",
      password: "",
      error: "",
      store: store,
    };
  },
  methods: {
    async handleLogin() {
      this.error = "";
      try {
        const response = await axios.post(
          `${this.store.api_root}/api/v2/support/login`,
          {
            email: this.email,
            password: this.password,
          },
          {
            withCredentials: true,
          },
        );
        this.store.account = response.data;
        localStorage.setItem("account", JSON.stringify(response.data));
        this.$router.push("/support-hub");
      } catch (err) {
        this.error = err.response?.data?.error || "Login failed.";
      }
    },
  },
};
</script>
